
  <div class="w-full flex flex-col items-center justify-center gap-4 p-4">
    <i class="fa-solid fa-chart-simple text-4xl text-zinc-500"></i>
    <span class="text-zinc-500 text-sm">Sem dados para o período</span>
  </div>
